import { render, staticRenderFns } from "./applicant-info.vue?vue&type=template&id=527c54aa&"
import script from "./applicant-info.vue?vue&type=script&lang=js&"
export * from "./applicant-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports